<div class="box">
  <div class="box-row header">
    <app-header-bar
      [backRoute]="'/workflows/' + workflowId + '/executions'"
      [title]="title"
      [autoTranslateTitle]="false"
    ></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    @if (execution) {
      <div class="card mb-3">
        <div class="card-body">
          <div class="row mt-2">
            <div class="col-md-6 mb-3">
              <h6 class="fw-bold">{{ 'job.singular' | translate }}</h6>
              <p class="card-text">{{ execution.jobName }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <h6 class="fw-bold">{{ 'mdm.singular' | translate }}</h6>
              <p class="card-text">{{ execution.handheldName }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <h6 class="fw-bold">{{ 'worker.singular' | translate }}</h6>
              <p class="card-text">{{ execution.workerName }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <h6 class="fw-bold">{{ 'workflow.status' | translate }}</h6>
              <p class="card-text" [innerHTML]="execution.status | toStatusBadge"></p>
            </div>
            <div class="col-md-6 mb-3">
              <h6 class="fw-bold">{{ 'createdAt' | translate }}</h6>
              <p class="card-text">{{ execution.createdAt | dateTime }}</p>
            </div>
            <div class="col-md-6 mb-3">
              <h6 class="fw-bold">{{ 'lastUpdatedAt' | translate }}</h6>
              <p class="card-text" [innerHTML]="execution.lastUpdatedAt | timeAgo"></p>
            </div>
          </div>
          <div class="row mb-3">
            <app-reusable-tabs [tabConfig]="editorTabsConfig"></app-reusable-tabs>
          </div>
          <div class="row">
            <h6 class="fw-bold">{{ 'workflow.execution.currentResult' | translate }}</h6>
            <ngx-monaco-editor
              class="full-size"
              [options]="editorOptions"
              [(ngModel)]="currentResult"
            ></ngx-monaco-editor>
          </div>
        </div>
      </div>
    }

    <ng-template #stepTemplate>
      <ngx-monaco-editor
        class="full-size"
        [options]="editorOptions"
        [(ngModel)]="currentStep"
      ></ngx-monaco-editor>
    </ng-template>
    <ng-template #dataTemplate>
      <ngx-monaco-editor
        class="full-size"
        style="height: 800px"
        [options]="editorOptions"
        [(ngModel)]="currentData"
      ></ngx-monaco-editor>
    </ng-template>
    <div class="row">
      @if (execution) {
        <app-datatable
          [dataSource]="source"
          [columns]="columns"
          [identifier]="'workflow-execution-events/' + execution.id"
          [actionNew]="false"
          [searchEnabled]="false"
          [customActions]="customActions"
        >
          <app-empty-table [icon]="'event_list'" [emptyText]="'workflow.event.empty_text' | translate"> </app-empty-table>
        </app-datatable>
      }

      <app-error [error]="error"></app-error>
    </div>
  </div>
</div>
